import Vue from 'vue';
import Router from 'vue-router';
import { isMobile } from '@/utils/device';

Vue.use(Router);

// 动态加载设备组件
const loadDeviceComponent = () =>
  isMobile()
    ? () => import('@/mobile/Home.vue')
    : () => import('@/pc/Home.vue');

export default new Router({
  routes: [{
    path: '/',
    component: () => import('@/layouts/' + (isMobile() ? 'MobileLayout' : 'PCLayout')),
    children: [{
      path: '',
      component: loadDeviceComponent()
    }]
  }]
});
